import { Routes, Route, Navigate } from "react-router-dom";
import Express from "./Express"; 
import Aviation from './Aviation';
import DomesticExpress from './DomesticExpress';
import EcomSolution from './EcomSolution';
import FinancialService from './FinancialServices';
import InternationalExpress from './InternationalExpress';
import MMS from './MMS';
import Travel from './TravelTour';
import Visatronix from './Visatronix';

const expressRoutes = [

    {routeName: 'domesticexpress' , component: <DomesticExpress/>},
    {routeName: 'internationalexpress' , component: <InternationalExpress/>},
    {routeName: 'ecom-solutions' , component: <EcomSolution/>},
    {routeName: 'travel-and-tour' , component: <Travel/>},
    {routeName: 'visatronix' , component: <Visatronix/>},
    {routeName: 'financial-services' , component: <FinancialService/>},
    {routeName: 'mms' , component: <MMS/>},
    {routeName: 'aviation' , component: <Aviation/>},
    
];

const ExpressRoutes = () => {
    return (
    <Routes>
       {expressRoutes.map((route, key)=> ( <Route key={key} path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/"/> }/>
    </Routes>)
}

export default ExpressRoutes;